import { ServerSetting } from '@asamco/base';
import { AsamcoSignalrBase } from './asamco-signalr-base';

export abstract class CspSignalrBase extends AsamcoSignalrBase {
	protected getBackend(): ServerSetting {
		return this.auth.userSession.loggedInBackends.find(b => b.name === 'CSPPlatform');
	}

	protected getAccessTokenFactory() {
		return () => new Promise<string>((resolve, reject) => {
			const backend = this.getBackend();
			resolve(backend.token);
		});
	}
}
